import React, { useState } from "react";
import IntlMessages from "@iso/components/utility/intlMessages";
import FormModalWrapper from "./FormModal.styles";
import {Button } from "antd";
import { Form as FormComponent } from "@iso/containers/Pages/Form/Form";

const FormModal = (props) => {

  const cancelModal = () => {
    props.cancelFormModal();
  };

  return (
    <>
      <FormModalWrapper
        width={1200}
        destroyOnClose={true}
        visible={props.isShowFormModal}
        title={`Forms`}
        onCancel={cancelModal}
        footer={[
          <Button key="back" onClick={cancelModal} className="cancel-button">
            {<IntlMessages id="propertyPage.modal.cancel" />}
          </Button>,
        ]}
      >
        {/*
          Mount the Forms page only while this modal is open. This lives in the
          Topbar, so it renders on EVERY page — with forceRender it kept a second
          Form instance permanently mounted app-wide, and that instance ran the
          same fetches as the real /manage-forms page, doubling every request (a
          page click fired two). Restoring the active property is handled app-wide
          by PrivateLayout, so nothing depends on this staying mounted.
        */}
        {props.isShowFormModal && (
          <FormComponent isShowFormModal={props.isShowFormModal}></FormComponent>
        )}
      </FormModalWrapper>
    </>
  );
};

export default FormModal;
